import React, { useState } from "react";
import Banner from "./Banner";
import Slide from "./Slide";
import Footer from "../footer/Footer";
import { SkeletonSlideRightSideComponent } from "./AllCategory/Skeleton";
import AllProductCategory from "./AllCategory/AllProductCategory";
import "./home.css";
import { Link } from "react-router-dom";

const Maincomponent = () => {
  const [loading, setlLoading] = useState(false);

  return (
    <div>
      <div className="home_section">
        <div className="banner_part">
          <Banner />
        </div>
        <div className="slide_part">
          <div className="left_slide">
            <Slide
              title="Deal of the Day"
              loading={loading}
              setlLoading={setlLoading}
            />
          </div>
          {loading ? (
            <SkeletonSlideRightSideComponent />
          ) : (
            <div className="right_slide">
              <h4>Festival latest launches</h4>
              <img
                src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/Jupiter/Launches/T3/DesktopGateway_CategoryCard2x_758X608_T3._SY608_CB639883570_.jpg"
                alt="rightimg"
              />
              <p className="p-show-more">
                <Link
                  to="/festival/launches/products"
                  className="btn-see-more-latest-launches"
                >
                  see more
                </Link>
              </p>
            </div>
          )}
        </div>
        <AllProductCategory />
      </div>
      <Footer />
    </div>
  );
};

export default Maincomponent;
